<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "BackofficeRouteIndex"
}
</script>

<style scoped>

</style>
